var map = {
	"./frame--horizontal.png": 251,
	"./frame_1.png": 252,
	"./frame_2.png": 253,
	"./frame_3.png": 254,
	"./shadow--horizontal.png": 255,
	"./shadow--horizontal.webp": 256,
	"./shadow.png": 257,
	"./shadow.webp": 258,
	"./star-map.svg": 259,
	"./star-map_bg-1.png": 260,
	"./star-map_bg-2.png": 261,
	"./star-map_bg-3.png": 262,
	"./star-map_bg-4.png": 263,
	"./star-map_bg-5.png": 264,
	"./star-map_black.png": 265,
	"./star-map_white.png": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;